<div class="md:p-4 pt-8 md:pt-4">
  <h1 class="font-bold text-2xl mb-2 mt-[.75rem] text-center capitalize">
    Complete financial clarity for a price of a coffee
  </h1>
  <span class="block text-center text-lg text-gray-600 mb-4"
    >Here's why you'll love organising with Prefund Pro:</span
  >

  <div>
    <div
      class="bg-blue-100 text-blue-900 rounded-lg p-4 max-w-[450px] m-auto rounded-bl-none rounded-br-none"
    >
      <ul class="pl-4 mb-0">
        <li class="mb-4 flex flex-col md:flex-row items-start md:items-center">
          <mat-icon class="align-middle mr-4">replay</mat-icon>
          <span>
            <span class="block font-bold">Periodic Tags</span>
            <span>Plan your expenditure and income on a monthly basis</span>
          </span>
        </li>
        <li class="mb-4 flex flex-col md:flex-row items-start md:items-center">
          <mat-icon class="align-middle mr-4">inventory_2</mat-icon>
          <span>
            <span class="block font-bold">Archived Tags</span>
            <span>Hide tags from the sidebar and from autocomplete</span>
          </span>
        </li>
        <li class="mb-4 flex flex-col md:flex-row items-start md:items-center">
          <mat-icon class="align-middle mr-4">palette</mat-icon>
          <span>
            <span class="block font-bold">Extra Tag Colors</span>
            <span>Let your tags shine with extra beautiful colors</span>
          </span>
        </li>

        <li class="mb-4 flex flex-col md:flex-row items-start md:items-center">
          <mat-icon class="align-middle mr-4">star</mat-icon>
          <span>
            <span class="block font-bold">More PRO features on the way</span>
            <span
              >Check out our
              <a
                href="{{ environment.environment.urls.roadmap }}"
                target="_blank"
                class="underline"
                >roadmap</a
              >
              to see what's cookin'.</span
            >
          </span>
        </li>
        <li class="flex flex-col md:flex-row items-start md:items-center">
          <mat-icon class="align-middle mr-4">favorite</mat-icon>
          <span>
            <span class="block font-bold">Support indie development</span>
            <span>Prefund is made by an independent developer</span>
          </span>
        </li>
      </ul>
    </div>
  </div>

  <div class="max-w-[450px] m-auto">
    <mat-radio-group [(ngModel)]="interval">
      <div class="w-full p-2 border border-b-0">
        <mat-radio-button class="example-margin mr-2" value="month"
          >$4 / month</mat-radio-button
        >
      </div>
      <div class="w-full p-2 border">
        <mat-radio-button class="example-margin" value="year"
          >$40 / year (save 15%)</mat-radio-button
        >
      </div>
    </mat-radio-group>
  </div>

  <div class="mb-4 max-w-[450px] m-auto">
    <button
      mat-flat-button
      (click)="checkout(interval)"
      [disabled]="isLoading"
      class="w-full !rounded-none !rounded-bl-lg !rounded-br-lg p-2"
    >
      {{ isLoading ? "" : "Subscribe to Prefund Pro" }}
      <mat-spinner
        class="m-auto grayscale scale-[0.25] opacity-50 inline"
        *ngIf="isLoading"
      ></mat-spinner>
    </button>
  </div>

  <p class="text-xs text-gray-500 text-center mb-4 max-w-[450px] m-auto">
    Safe payments are provided by Stripe. Charges only apply after 7 days of
    trial period. Cancel anytime. Free refund is available within 30 days of
    purchase.
    <a
      href="{{ environment.environment.urls.pricing }}"
      class="underline"
      target="_blank"
      >Learn more</a
    >
  </p>
</div>
